export namespace RydFeatures {
    // Define valid feature names as a union of specific strings.
    export type FTName =
        'CHORD_INSPECTOR'
        | 'DEMO_SONGS'
        | 'INSPECTOR_PANEL'
        | 'LIBRARY_BOOKMARKS'
        | 'LIBRARY_PALETTE'
        | 'LOGIN_REQUIRED'
        | 'USE_FAKE_LOGIN';

    const featureTogglesStates: Record<FTName, boolean> = {
        CHORD_INSPECTOR: false,
        DEMO_SONGS: false,
        INSPECTOR_PANEL: true,
        LIBRARY_BOOKMARKS: true,
        LIBRARY_PALETTE: true,
        LOGIN_REQUIRED: true,
        USE_FAKE_LOGIN: true,
    };

    console.log('INIT: FEATURE TOGGLES', featureTogglesStates);

    export namespace Toggle {
        export const isOn = (feature: FTName): boolean => {
            return featureTogglesStates[feature] === true;
        }

        export const isOff = (feature: FTName): boolean => {
            return featureTogglesStates[feature] === false;
        }
    }
}

